import React from 'react';
import { Container, Paper, Typography, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Necesitaremos un ícono

function HelpPage() {
  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Guía de Uso y Preguntas Frecuentes
        </Typography>
        <Typography paragraph>
          Bienvenido al portal de Participación Ciudadana. Aquí encontrarás todo lo que necesitas saber para presentar y gestionar tus solicitudes.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">¿Qué tipo de solicitud debo usar?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <strong>Queja:</strong> Expresión de insatisfacción con un servicio o funcionario.<br />
                <strong>Denuncia:</strong> Notificación de un posible acto de corrupción o irregularidad.<br />
                <strong>Petición:</strong> Solicitud formal de información o de una acción específica.<br />
                <strong>Reclamo:</strong> Exigencia por un derecho incumplido.<br />
                <strong>Sugerencia:</strong> Propuesta para mejorar un servicio o proceso.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">¿Cómo presento una solicitud?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                1. En la página principal, selecciona el tipo de solicitud que deseas realizar.<br />
                2. Rellena el campo de descripción con todos los detalles posibles de tu caso.<br />
                3. Si lo deseas, puedes proporcionar tu nombre y correo electrónico para recibir notificaciones.<br />
                4. Haz clic en "Enviar Solicitud". ¡Asegúrate de guardar el código de seguimiento que te proporcionaremos!
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">¿Para qué sirve el código de seguimiento?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                El código de seguimiento es tu llave para conocer el estado de tu caso. Introdúcelo en la sección "Consultar Estatus de Solicitud" en la página principal para ver si tu solicitud ha sido recibida, está en proceso o ya fue resuelta.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Paper>
    </Container>
  );
}

export default HelpPage;